<template>
  <section>
    <!--工具条-->
    <el-col :span="24" style="padding-bottom: 0;" size="small">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-autocomplete v-model="filters.account" :fetch-suggestions="querySearch" size="small" placeholder="用户名"
                           :disabled="!isUser" clearable></el-autocomplete>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.didOrSnOrMac" size="small"  placeholder="DID/SN/MAC" clearable>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.model" placeholder="请选择设备类型" clearable size="small">
            <el-option v-for="device in deviceList" :value="device.board" :label="device.type"
                       :key="device.board"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.feature" placeholder="请选择功能" clearable size="small">
            <el-option v-for="feature in featureList"
                       :value="parseInt(feature.bit)"
                       :label="feature.feature"
                       :key="feature.bit"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="filters.date" type="daterange" range-separator="至" start-placeholder="开始日期"
                          end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                          :default-time="['00:00:00', '23:59:59']" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getRecord()" size="small" icon="el-icon-search">查询</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <template>
      <el-table :data="recordList" highlight-current-row v-loading="loading" style="width: 100%;" size="small">
        <el-table-column type="index" width="60" :index="indexMethod"></el-table-column>
        <el-table-column prop="account" label="用户名" width="100" align="center"></el-table-column>
        <el-table-column prop="model" label="设备类型"  show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="deviceSn" label="设备序列号" width="140" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="did" label="DID" width="140" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="mac" label="MAC" width="140" align="center"></el-table-column>
        <el-table-column prop="feature" label="功能" width="140" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="price" label="价格" width="100" align="center"></el-table-column>
        <el-table-column prop="createTime" label="生成时间" width="180" align="center"></el-table-column>
        <el-table-column prop="orderNumber" label="订单号" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="activeCode" label="激活码" min-width="150" align="center"></el-table-column>
      </el-table>


      <!--工具条-->
      <el-col :span="24">
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
                       :total="total" :current-page.sync="page" style="float:right;">
        </el-pagination>
      </el-col>
    </template>

  </section>
</template>
<script>
import {getRecordInfo, getRecordList, getDeviceInfo, getFeatureInfo, listUsername} from "../../../api/api";
import {isAuth} from "../../../utils";

export default {
  data() {
    return {
      filters: {
        account: "",
        model: "",
        feature: "",
        date: "",
        didOrSnOrMac:""
      },
      curUser: "",
      isRec: false,
      isUser: false,
      users: [],
      userList: [],
      featureList: [],
      deviceList: [],
      loading: false,
      recordList: [],
      total: 0,
      currentPage: 1,
      page: 1
    };
  },
  methods: {
    querySearch(queryString, cb) {
      let users = this.users;
      let results = queryString ? users.filter(this.createFilter(queryString)) : users;
      cb(results);
    },
    createFilter(queryString) {
      return (user) => {
        return (user.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    indexMethod(row) {
      return row + (this.page - 1) * 10 + 1;
    },

    handleCurrentChange(val) {
      this.page = val;
      if (this.isRec) {
        this.getRecordList();
      } else {
        this.getRecordInfo(this.curUser);
      }
    },
    getUsers() {
      listUsername().then((res) => {
        this.users = res.data.userList;
      });
    },
    getDeviceInfo() {
      getDeviceInfo().then((res) => {
        this.deviceList = res.data.deviceList.content;
        this.getFeatureInfo();
      });
    },
    getFeatureInfo() {
      getFeatureInfo().then((res) => {
        this.featureList = res.data.featureList.content;
        if (this.isRec) {
          this.getRecordList();
        } else {
          this.getRecordInfo(this.curUser);
        }

      });
    },

    //获取个人订单列表
    getRecordInfo(u) {
      let para = {
        page: this.page - 1,
        size: 10,
        account: u,
        model: this.filters.model,
        feature: this.filters.feature,
        stime: this.filters.date ? this.filters.date[0] : undefined,
        etime: this.filters.date ? this.filters.date[1] : undefined,
        content: this.filters.didOrSnOrMac
      };
      this.loading = true;
      getRecordInfo(para).then((res) => {
        let orderList = [];
        if (res.data.code === 0) {
          let records = res.data.recordList.content;
          for (let i = 0; i < records.length; i++) {
            let orderMap = {};
            orderMap.account = records[i].account;
            orderMap.deviceSn = records[i].deviceSn;
            orderMap.price = records[i].price;
            orderMap.mac = records[i].mac;
            orderMap.did = records[i].did;
            orderMap.time = records[i].time;
            orderMap.orderNumber = records[i].orderNumber;
            orderMap.activeCode = records[i].activeCode;
            for (let j = 0; j < this.deviceList.length; j++) {
              if (records[i].model.toLowerCase() === this.deviceList[j].board.toLowerCase()) {
                orderMap.model = this.deviceList[j].type;
              }
            }

            // let func = parseInt(records[i].feature).toString(2).split("").reverse();
            // let funcArray = [];
            // let bitArray = [];
            // for(let m = 0;m < this.featureList.length;m++){
            //     bitArray.push(this.featureList[m].bit);
            // }
            // for(let j = 0;j < func.length;j++){
            //     if(func[j] == '1'){
            //         funcArray.push(this.featureList[bitArray.indexOf(j)].feature);
            //     }
            // }
            // orderMap.feature = funcArray.join(" ");
            let bitArray = [];
            let funcArray = [];
            let func = records[i].bit.split(",").map(Number);
            for (let m = 0; m < this.featureList.length; m++) {
              bitArray.push(this.featureList[m].bit);
            }

            for (let j = 0; j < func.length; j++) {
              const matchedItem = this.featureList.find(item => item.bit === func[j]);
              if (matchedItem) {
                funcArray.push(matchedItem.feature);
              }
            }
            orderMap.feature = funcArray.join(" ");
            orderMap.createTime = records[i].createTime;
            orderList.push(orderMap);
          }
          this.total = res.data.recordList.totalElements;
          this.recordList = orderList;
        } else {
          this.$message.error("获取订单列表失败，请稍后重新获取");
        }
        this.loading = false;
      });

    },
    //获取订单列表
    getRecordList() {
      let para = {
        page: this.page - 1,
        size: 10,
        account: this.filters.account,
        model: this.filters.model,
        feature: this.filters.feature,
        stime: this.filters.date ? this.filters.date[0] : undefined,
        etime: this.filters.date ? this.filters.date[1] : undefined,
        content: this.filters.didOrSnOrMac
      };
      this.loading = true;
      getRecordList(para).then((res) => {
        let orderList = [];
        if (res.data.code === 0) {
          let records = res.data.recordList.content;
          for (let i = 0; i < records.length; i++) {
            let orderMap = {};
            orderMap.account = records[i].account;
            orderMap.deviceSn = records[i].deviceSn;
            orderMap.mac = records[i].mac;
            orderMap.did = records[i].did;
            orderMap.price = records[i].price;
            orderMap.time = records[i].time;
            orderMap.orderNumber = records[i].orderNumber;
            orderMap.activeCode = records[i].activeCode;
            for (let j = 0; j < this.deviceList.length; j++) {
              if (records[i].model.toLowerCase() === this.deviceList[j].board.toLowerCase()) {
                orderMap.model = this.deviceList[j].type;
              }
            }

            // let func = parseInt(records[i].feature).toString(2).split("").reverse();
            // let funcArray = [];
            // let bitArray = [];
            // for (let m = 0; m < this.featureList.length; m++) {
            //   bitArray.push(this.featureList[m].bit);
            // }
            // for (let j = 0; j < func.length; j++) {
            //   if (func[j] == "1") {
            //     funcArray.push(this.featureList[bitArray.indexOf(j)].feature);
            //   }
            // }
            // orderMap.feature = funcArray.join(" ");
            let bitArray = [];
            let funcArray = [];
            let func = records[i].bit.split(",").map(Number);
            for (let m = 0; m < this.featureList.length; m++) {
              bitArray.push(this.featureList[m].bit);
            }

            for (let j = 0; j < func.length; j++) {
              const matchedItem = this.featureList.find(item => item.bit === func[j]);
              if (matchedItem) {
                funcArray.push(matchedItem.feature);
              }
            }
            orderMap.feature = funcArray.join(" ");
            orderMap.createTime = records[i].createTime;
            orderList.push(orderMap);
          }
          this.total = res.data.recordList.totalElements;
          this.recordList = orderList;
        } else {
          this.$message.error("获取订单列表失败，请稍后重新获取");
        }
        this.loading = false;
      });

    },
    getRecord() {
      this.page=1;
      if (this.isRec) {
        this.getRecordList();
      } else {
        this.getRecordInfo(this.curUser);
      }
    }
  },
  activated() {
    this.curUser = sessionStorage.getItem("username");
    this.isRec = isAuth("record:list");

    this.isUser = isAuth("user:list");
    this.getUsers();
    if (!this.isRec) {
      this.filters.account = this.curUser;
    }
    this.getDeviceInfo();
  }
};

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/modules/sys/rec.vue